<div class="example-container">
    <div class="pdf-view">
        <module-container type="full-height">
            <pdf-viewer uuid="7a64fb97-8074-4b38-bd15-b37423acd525"></pdf-viewer>
        </module-container>
    </div>
    
    <div class="pdf-form-container">
        <module-container>
            <form class="pdf-form" [formGroup]="pdfForm" (ngSubmit)="changePDF()">
                 
                <!-- Login Label -->
                <span class="login-label">Try the pdf out!</span>

                <!-- Username -->
                <mat-form-field color="primary" class="login-input-field" appearance="outline">
                    <mat-label><mat-icon>code</mat-icon> uuid</mat-label>
                    <input formControlName="pdfUuid" matInput placeholder="uuid">
                </mat-form-field>

                <button mat-flat-button class="login-submit-button" type="submit" color="accent"> Search File</button>
            </form>
        </module-container>
    </div>
</div>